import { render, staticRenderFns } from "./Forwarding.vue?vue&type=template&id=3d400f91"
import script from "./Forwarding.vue?vue&type=script&lang=js"
export * from "./Forwarding.vue?vue&type=script&lang=js"
import style0 from "./Forwarding.vue?vue&type=style&index=0&id=3d400f91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports